export default __webpack_public_path__ + "static/media/earphones.03b40cf2.png";